"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.names = exports.methods = void 0;

var _huang = _interopRequireDefault(require("./huang"));

var _intermodes = _interopRequireDefault(require("./intermodes"));

var _isodata = _interopRequireDefault(require("./isodata"));

var _li = _interopRequireDefault(require("./li"));

var _maxEntropy = _interopRequireDefault(require("./maxEntropy"));

var _mean = _interopRequireDefault(require("./mean"));

var _minError = _interopRequireDefault(require("./minError"));

var _minimum = _interopRequireDefault(require("./minimum"));

var _moments = _interopRequireDefault(require("./moments"));

var _otsu = _interopRequireDefault(require("./otsu"));

var _percentile = _interopRequireDefault(require("./percentile"));

var _renyiEntropy = _interopRequireDefault(require("./renyiEntropy.js"));

var _shanbhag = _interopRequireDefault(require("./shanbhag"));

var _triangle = _interopRequireDefault(require("./triangle"));

var _yen = _interopRequireDefault(require("./yen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {('huang'|'intermodes'|'isodata'|'li'|'maxentropy'|'mean'|'minerror'|'minimum'|'moments'|'otsu'|'percentile'|'renyientropy'|'shanbhag'|'triangle'|'yen')} ThresholdAlgorithm
 */
const methods = {
  huang: _huang.default,
  intermodes: _intermodes.default,
  isodata: _isodata.default,
  li: _li.default,
  maxentropy: _maxEntropy.default,
  mean: _mean.default,
  minerror: _minError.default,
  minimum: _minimum.default,
  moments: _moments.default,
  otsu: _otsu.default,
  percentile: _percentile.default,
  renyientropy: _renyiEntropy.default,
  shanbhag: _shanbhag.default,
  triangle: _triangle.default,
  yen: _yen.default
};
exports.methods = methods;
const names = {};
exports.names = names;
Object.keys(methods).forEach(name => {
  names[name] = name;
});